import { useState } from 'react';
import Menu from '@mui/material/Menu';
import SwapVertRoundedIcon from '@mui/icons-material/SwapVertRounded';
import ActionIconButton from '@components/ActionIconButton';
import { CssMenuItem } from '@components/Select';
import { useTranslation } from '@hooks';
import { ConversationSorting } from '@constants/conversations';

const SortMenu = ({ value, onChange }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const { t } = useTranslation();

    const options = [
        { value: ConversationSorting.ActivityNewestFirst, label: t('InboxPage.activityNewestFirst') },
        { value: ConversationSorting.ActivityOldestFirst, label: t('InboxPage.activityOldestFirst') },
        { value: ConversationSorting.CreatedAtNewestFirst, label: t('InboxPage.createdAtNewestFirst') },
        { value: ConversationSorting.CreatedAtOldestFirst, label: t('InboxPage.createdAtOldestFirst') },
    ];

    const onSelect = optionValue => {
        setAnchorEl(null);
        if (optionValue !== value) {
            onChange(optionValue);
        }
    };

    return (
        <>
            <ActionIconButton
                title={t('filters.sorting')}
                onClick={event => setAnchorEl(event.currentTarget)}
                size="small"
                sx={{ '& svg': { fontSize: 20, color: 'var(--text-secondary)' } }}
            >
                <SwapVertRoundedIcon />
            </ActionIconButton>
            <Menu
                anchorEl={anchorEl}
                open={!!anchorEl}
                onClose={() => setAnchorEl(null)}
                sx={{ '.MuiMenu-paper': { borderRadius: '8px', minWidth: 220 } }}
            >
                {options.map(option => (
                    <CssMenuItem
                        key={option.value}
                        selected={option.value === value}
                        onClick={() => onSelect(option.value)}
                    >
                        {option.label}
                    </CssMenuItem>
                ))}
            </Menu>
        </>
    );
};

export default SortMenu;
